import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { get } from 'lodash';
import { SelectItem, ConfirmationService, MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { ICustomer } from '../../interfaces/customer';
import { ICustomerForm } from '../../interfaces/customer-form';
import { IDefaultOfficeHours } from '../../interfaces/default-office-hours';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IUser } from '../../interfaces/user';
import { IUserFilter } from '../../interfaces/user-filter';
import { CustomerService, OrganisationSettingService } from '../../services';
import { FileStorageService } from '../../services';
import { LoggerService } from '../../services';
import { MapService } from '../../services';
import { OfficeHoursService } from '../../services';
import { OrganisationsService } from '../../services';
import { TaggedLogger } from '../../services';
import { TaskService } from '../../services';
import { TermsConditionsService } from '../../services';
import { TradePlateService } from '../../services';
import { UserService } from '../../services';
import { getCombinedParameters } from '../../utils/getCombinedParameters';
import { InputHelper } from '../../utils/input.helper';

import { flatten } from '../../utils/flatten';
import { OrgStructureComponent } from '../manage-org-structure/manage-org-structure.component';
import { tryParseInt } from '../../utils/tryParseInt';
import { SupplierService } from 'src/app/services';
import { ISystemSettings } from '../../interfaces/system-settings';
import { SettingsService } from '../../services';
import { IServiceDeliveryGroup } from '../../interfaces/service-delivery-group';
import { IERegion } from '../../interfaces/eregion';
import { OrganisationSettingEnum } from '../../enums/organisation-settings';
import { OrganisationTypeEnum } from '../../enums/organisation-types';
import { IAgreedTermsConditions } from '../../interfaces/terms-conditions-version';
import { VehicleLifecycleService } from '../../services/vehicle-lifecycle.service';
import { IVehicleLifeCycleProviderConnection } from '../../interfaces/vehicle-life-cycle/vehicle-life-cycle-provider-connection';
import { IVehicleLifeCycleProvider } from '../../interfaces/vehicle-life-cycle/vehicle-life-cycle-provider';
import { MobileInformationService } from 'src/app/services/mobile-information.service';
import { MobileInformation } from 'src/app/interfaces/mobile-informations';
import { AddressAutoCompletionService } from '../../services/address-auto-completion.service';
import { RouteRecommendationService } from '../../services/route-recommendation.service';

@Component({
  selector: 'page-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.scss'],
  encapsulation: ViewEncapsulation.None, // todo: come check
})
export class CustomerDetailsComponent implements OnInit {
  private readonly logger: TaggedLogger;

  public customerdata: ICustomer;
  public mobileInformations: MobileInformation[];
  public readonly OrganisationTypeEnum = OrganisationTypeEnum;
  public defaultSearchType: boolean = false;
  public junoEnabled: boolean = false;
  public defaultSearchTypeOptions: SelectItem[] = [
    { label: 'Job Search', value: false },
    { label: 'Route Search', value: true },
  ];
  public customer: ICustomerForm;
  public newCustomerForm: UntypedFormGroup;
  public id: number;
  public user: string;
  public openonWeekends: boolean = false;
  public customerorgId: number;
  public currentUserOrgTypeId: number;
  public termsConditions: IAgreedTermsConditions;
  public logoUrl: string;
  public currentUser: IUser;
  public organisationUsersFilterVal: IUserFilter;
  public stepTypes: SelectItem[] = [];
  public selectedStepTypes: any[] = [];
  public customerRegions: string[] = [];
  public invalidOrganisationName: boolean = false;
  private defaultMinWindow = 4;

  private defaultBillingWaitDays: number = 7;

  private mobileNumberRegExp = new RegExp(/^\d{3}\s?\d{3}\s?\d{4}$/);

  public selectedTradePlate: any;
  public selectedApiDefaultUserId: string;
  public apiKey: string = '';
  public apiKeyRevealed: boolean = false;
  public apiKeyLoading: boolean = false;
  public showApiKeyChangeDialog: boolean = false;
  public apiKeyDialogMessage: any = {
    createNewKeyCheckMsg: 'Are you sure you will like to create a new api key?',
    updatedExistingKeyCheckMsg:
      'Are you sure you will like to change the api key? If you click yes, this will invalidate the current key and users will be required to authenticate with the new key on future access to the API.',
    confirmNewKeyCreatedMsg: 'New API Key generated',
    confirmExistingKeyUpdatedMsg: 'API Key updated',
  };
  public isVmeMode: boolean = false;
  private organisationtypespromise: Promise<any>;
  private organisationUsersPromise: Promise<any>;
  @ViewChild(OrgStructureComponent) orgStructure: OrgStructureComponent;

  systemSettings: ISystemSettings;

  engineiusRegion: IERegion;
  minCollectionWindow = new UntypedFormControl(this.defaultMinWindow);
  minDeliveryWindow = new UntypedFormControl(this.defaultMinWindow);

  vehicleLifeCycleManageProvidersVisible: boolean = false;
  vehicleLifeCycleProviderUpdateSaving: boolean = false;
  vehicleLifeCycleProviders: IVehicleLifeCycleProvider[] = [];
  vehicleLifeCycleProviderConnections: IVehicleLifeCycleProviderConnection[] = [];
  vehicleLifeCycleProviderConnectionFormGroup: UntypedFormGroup;
  vehicleLifeCycleSelectedProvider: IVehicleLifeCycleProvider = null;

  constructor(
    private customerService: CustomerService,
    private mobileInformationService: MobileInformationService,
    private route: ActivatedRoute,
    public inputHelper: InputHelper,
    private router: Router,
    private officeHoursService: OfficeHoursService,
    private http: HttpClient,
    public messageService: MessageService,
    private userService: UserService,
    private tcService: TermsConditionsService,
    private confirmationService: ConfirmationService,
    private fileStorageService: FileStorageService,
    private mapService: MapService,
    private tradePlateService: TradePlateService,
    private organisationService: OrganisationsService,
    private taskService: TaskService,
    private supplierService: SupplierService,
    loggerService: LoggerService,
    private settingsService: SettingsService,
    private organisationSettingService: OrganisationSettingService,
    private vehicleLifeCycleService: VehicleLifecycleService,
    private addressAutoCompletionService: AddressAutoCompletionService,
    private routeRecommendationService: RouteRecommendationService,
  ) {
    this.logger = loggerService.taggedLogger('component:customer-details');
  }

  allorganisationsubtypes: any[] = [];
  organisationsubtypes: SelectItem[] = [];
  organisationtypes: SelectItem[];
  organisationUsers: SelectItem[];

  organisationContractTypes: SelectItem[];
  selectedOrganisationContractType: number;

  serviceDeliveryGroupOptions: SelectItem[];
  serviceDeliveryGroups: IServiceDeliveryGroup[];
  selectedServiceDeliveryGroupId: number;
  selectedServiceDeliveryGroup: IServiceDeliveryGroup;

  //values are taken from Xero API (enum Xero.Api.Core.Model.Types.PaymentTermType)
  paymentTermsTypes: SelectItem[] = [
    { label: '', value: -1 },
    { label: 'Following Month', value: 0 },
    { label: 'After Bill Date', value: 1 },
    { label: 'Current Month', value: 2 },
    { label: 'Days After Bill Month', value: 3 },
    { label: 'After Invoice Month', value: 4 },
  ];

  twoFactorStatuses: SelectItem[] = [
    { label: 'Disabled', value: 1 },
    { label: 'Enabled', value: 2 },
    { label: 'Required', value: 3 },
  ];

  transportModeOptions: SelectItem[] = [
    { label: 'Driving', value: 0 },
    { label: 'Public Transport', value: 1 },
    { label: 'Walking', value: 2 },
    { label: 'Cycling', value: 3 },
  ];

  tabIndex: number = 0;

  public get defaultSupportEmail(): string {
    if (
      this.customerdata?.organisationTypeId == OrganisationTypeEnum.Customer ||
      this.customerdata?.organisationTypeId == OrganisationTypeEnum.SaaSCustomer
    ) {
      return this.systemSettings?.defaultCustomerSupportEmail;
    }
    return this.systemSettings?.defaultSupplierSupportEmail;
  }

  private DEFAULT_CARRYOVER_ADDITIONAL_MILEAGE_THRESHOLD = 15;

  async ngOnInit() {
    this.customerorgId = this.route.snapshot.params['orgId'];
    this.initOrganisationUserFilter(this.route.snapshot.params['id']);
    this.userService.getCurrentUserOrg().then((res) => {
      this.currentUserOrgTypeId = res.organisationTypeId;
      this.isVmeMode = res.organisationTypeId == 1;

      if (!this.isVmeMode && this.newCustomerForm && this.newCustomerForm.get('name')) {
        this.newCustomerForm.get('name').disable();
      }
      this.initAddressAutoCompletionFields();
    });
    this.userService.getLoggedUser().then((res) => (this.currentUser = res));
    this.getOrganisationUsers(this.organisationUsersFilterVal);
    this.taskService.getStepTypes().then((res) => {
      res.forEach((x) => this.stepTypes.push({ label: x.name, value: x.id }));
    });

    getCombinedParameters(this.route).subscribe(async (params: Params) => {
      this.id = tryParseInt(params['id']) as number;
      //this.logger.debug('Id:', this.id);
      this.user = params['user'];
      //this.logger.debug('user:', this.user);
      this.organisationtypespromise = this.getOrganisationTypes();

      this.organisationContractTypes = [];
      this.customerService.getContractTypes().then((result) => {
        result.forEach((item) => {
          this.organisationContractTypes.push({ label: item.name, value: item.id });
        });
      });

      this.serviceDeliveryGroupOptions = [{ label: 'None', value: null }];

      this.organisationService.getServiceDeliveryGroups().then((result) => {
        this.serviceDeliveryGroups = result;
        result.forEach((item) => {
          this.serviceDeliveryGroupOptions.push({ label: item.name, value: item.id });
        });
      });

      const regexp = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );

      this.systemSettings = await this.settingsService.GetSystemSettings();

      // set formGroup instance
      this.customer = {
        id: 0,
        name: new UntypedFormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
        ),
        addressLine1: new UntypedFormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
        ),
        addressLine2: new UntypedFormControl(
          '',
          Validators.compose([null, Validators.maxLength(60)]),
        ),
        addressLine3: new UntypedFormControl(
          '',
          Validators.compose([null, Validators.maxLength(60)]),
        ),
        country: new UntypedFormControl('UK', Validators.compose([null, Validators.maxLength(35)])),
        city: new UntypedFormControl('', null),
        emailAddress: new UntypedFormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.maxLength(254),
            Validators.pattern(regexp),
          ]),
        ), //Validators.compose([Validators.required, Validators.maxLength(254), Validators.pattern(regexp)])),
        engineiusCustomerEmail: new UntypedFormControl(
          '',
          Validators.compose([Validators.maxLength(254), Validators.pattern(regexp)]),
        ),
        postcode: new UntypedFormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(8), NoEmptyString]),
        ),
        town: new UntypedFormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(35), NoEmptyString]),
        ),
        phoneNumber: new UntypedFormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.maxLength(20),
            Validators.pattern(this.mobileNumberRegExp),
          ]),
        ),
        companyRegistrationNumber: this.GetFormControlForCompanyRegNo(''),
        OrganisationTypeId: new UntypedFormControl(1, Validators.required),
        OrganisationSubTypeId: new UntypedFormControl(1),
        organisationContractTypeId: new UntypedFormControl(1),
        vatNumber: new UntypedFormControl('', Validators.compose([null, Validators.maxLength(9)])),
        website: new UntypedFormControl('', Validators.compose([null, Validators.maxLength(254)])),
        companyInfoURL: new UntypedFormControl(
          '',
          Validators.compose([null, Validators.maxLength(1024)]),
        ),
        ecMaxFlexTimeInMinutes: new UntypedFormControl(0),
        defaultAPIUserId: new UntypedFormControl('', null),
        gdprDays: new UntypedFormControl(
          '',
          Validators.compose([
            Validators.min(this.systemSettings.gdprDays_MinValue),
            Validators.max(this.systemSettings.gdprDays_MaxValue),
          ]),
        ),
        twoFactorStatus: new UntypedFormControl(1, null),
        transportMode: new UntypedFormControl(1, null),
        deactivationReason: new UntypedFormControl(null),
        preventAutomaticDeactivation: new UntypedFormControl(false),
        preventAutomaticDeactivationExpiryDate: new UntypedFormControl(''),
        invoiceAddress: {
          addressLine1: new UntypedFormControl(
            '',
            Validators.compose([Validators.required, Validators.maxLength(60), NoEmptyString]),
          ),
          addressLine2: new UntypedFormControl(
            '',
            Validators.compose([null, Validators.maxLength(60)]),
          ),
          addressLine3: new UntypedFormControl(
            '',
            Validators.compose([null, Validators.maxLength(60)]),
          ),
          town: new UntypedFormControl(
            '',
            Validators.compose([Validators.required, Validators.maxLength(35), NoEmptyString]),
          ),
          city: new UntypedFormControl('', null),
          country: new UntypedFormControl(
            'UK',
            Validators.compose([null, Validators.maxLength(35)]),
          ),
          postCode: new UntypedFormControl(
            '',
            Validators.compose([Validators.required, Validators.maxLength(8), NoEmptyString]),
          ),
          invoiceCompanyName: new UntypedFormControl('', Validators.maxLength(100)),
          invoiceContactFirstName: new UntypedFormControl('', Validators.maxLength(35)),
          invoiceContactLastName: new UntypedFormControl('', Validators.maxLength(35)),
          invoiceContactEmail: new UntypedFormControl(
            '',
            Validators.compose([Validators.maxLength(254), Validators.pattern(regexp)]),
          ),
          invoiceContactPhone: new UntypedFormControl('', Validators.maxLength(20)),
          invoiceContact2FirstName: new UntypedFormControl('', Validators.maxLength(35)),
          invoiceContact2LastName: new UntypedFormControl('', Validators.maxLength(35)),
          invoiceContact2Email: new UntypedFormControl(
            '',
            Validators.compose([Validators.maxLength(254), Validators.pattern(regexp)]),
          ),
          invoiceContact3FirstName: new UntypedFormControl('', Validators.maxLength(35)),
          invoiceContact3LastName: new UntypedFormControl('', Validators.maxLength(35)),
          invoiceContact3Email: new UntypedFormControl(
            '',
            Validators.compose([Validators.maxLength(254), Validators.pattern(regexp)]),
          ),
          paymentTermsType: new UntypedFormControl(),
          paymentTermsDays: new UntypedFormControl(),
          purchaseOrderNumber: new UntypedFormControl('', Validators.maxLength(100)),
          invoicePeriod: new UntypedFormControl(0),
          billingWaitDays: new UntypedFormControl(this.defaultBillingWaitDays),
        },
        organisationDetails: {
          isSelfInsured: new UntypedFormControl(false),
        },
        enableCustomInvoiceReport: new UntypedFormControl(false),
        defaultOfficeHours: this.officeHoursService.setOfficeHoursForm(null),
        logo: new UntypedFormControl(''),
        isAddTransactionFee: new UntypedFormControl(false),
        stepTypes: new UntypedFormControl([]),
        serviceDeliveryGroupId: new UntypedFormControl('', Validators.required),
        minCollectionWindow: this.minCollectionWindow,
        minDeliveryWindow: this.minDeliveryWindow,
        dateOfBirth: new UntypedFormControl(),
        allowCarryover: new UntypedFormControl(true),
        restrictCarryover: new UntypedFormControl(false),
        restrictWeekendCarryover: new UntypedFormControl(false),
        carryoverAdditionalMileageThreshold: new UntypedFormControl(
          this.DEFAULT_CARRYOVER_ADDITIONAL_MILEAGE_THRESHOLD,
          [Validators.required, Validators.min(0)],
        ),
        vehicleLifeCycleEnabled: new UntypedFormControl(false),
        supplierAppAccess: new UntypedFormControl(true),
        bypassOrderLimitations: new UntypedFormControl(false),
      };

      this.newCustomerForm = new UntypedFormGroup({
        name: this.customer.name,
        addressLine1: this.customer.addressLine1,
        addressLine2: this.customer.addressLine2,
        addressLine3: this.customer.addressLine3,
        dateOfBirth: this.customer.dateOfBirth,
        country: this.customer.country,
        city: this.customer.city,
        emailAddress: this.customer.emailAddress,
        engineiusCustomerEmail: this.customer.engineiusCustomerEmail,
        postcode: this.customer.postcode,
        town: this.customer.town,
        phoneNumber: this.customer.phoneNumber,
        companyRegistrationNumber: this.customer.companyRegistrationNumber,
        OrganisationTypeId: this.customer.OrganisationTypeId,
        OrganisationSubTypeId: this.customer.OrganisationSubTypeId,
        organisationContractTypeId: this.customer.organisationContractTypeId,
        vatNumber: this.customer.vatNumber,
        website: this.customer.website,
        companyInfoURL: this.customer.companyInfoURL,
        ecMaxFlexTimeInMinutes: this.customer.ecMaxFlexTimeInMinutes,
        logo: this.customer.logo,
        isAddTransactionFee: this.customer.isAddTransactionFee,
        defaultAPIUserId: this.customer.defaultAPIUserId,
        stepTypes: this.customer.stepTypes,
        gdprDays: this.customer.gdprDays,
        transportMode: this.customer.transportMode,
        twoFactorStatus: this.customer.twoFactorStatus,
        deactivationReason: this.customer.deactivationReason,
        preventAutomaticDeactivation: this.customer.preventAutomaticDeactivation,
        preventAutomaticDeactivationExpiryDate:
          this.customer.preventAutomaticDeactivationExpiryDate,
        invoiceAddress: new UntypedFormGroup({
          addressLine1: this.customer.invoiceAddress.addressLine1,
          addressLine2: this.customer.invoiceAddress.addressLine2,
          addressLine3: this.customer.invoiceAddress.addressLine3,
          town: this.customer.invoiceAddress.town,
          city: this.customer.invoiceAddress.city,
          country: this.customer.invoiceAddress.country,
          postCode: this.customer.invoiceAddress.postCode,
          invoiceCompanyName: this.customer.invoiceAddress.invoiceCompanyName,
          invoiceContactFirstName: this.customer.invoiceAddress.invoiceContactFirstName,
          invoiceContactLastName: this.customer.invoiceAddress.invoiceContactLastName,
          invoiceContactEmail: this.customer.invoiceAddress.invoiceContactEmail,
          invoiceContactPhone: this.customer.invoiceAddress.invoiceContactPhone,
          invoiceContact2FirstName: this.customer.invoiceAddress.invoiceContact2FirstName,
          invoiceContact2LastName: this.customer.invoiceAddress.invoiceContact2LastName,
          invoiceContact2Email: this.customer.invoiceAddress.invoiceContact2Email,
          invoiceContact3FirstName: this.customer.invoiceAddress.invoiceContact3FirstName,
          invoiceContact3LastName: this.customer.invoiceAddress.invoiceContact3LastName,
          invoiceContact3Email: this.customer.invoiceAddress.invoiceContact3Email,
          paymentTermsType: this.customer.invoiceAddress.paymentTermsType,
          paymentTermsDays: this.customer.invoiceAddress.paymentTermsDays,
          purchaseOrderNumber: this.customer.invoiceAddress.purchaseOrderNumber,
          invoicePeriod: this.customer.invoiceAddress.invoicePeriod,
          billingWaitDays: this.customer.invoiceAddress.billingWaitDays,
        }),
        organisationDetails: new UntypedFormGroup({
          isSelfInsured: this.customer.organisationDetails.isSelfInsured,
        }),
        defaultOfficeHours: new UntypedFormGroup({
          weekOfficeOpeningTime: this.customer.defaultOfficeHours.weekOfficeOpeningTime,
          weekOfficeClosingTime: this.customer.defaultOfficeHours.weekOfficeClosingTime,
          saturdayOpeningTime: this.customer.defaultOfficeHours.saturdayOpeningTime,
          saturdayClosingTime: this.customer.defaultOfficeHours.saturdayClosingTime,
          sundayOpeningTime: this.customer.defaultOfficeHours.sundayOpeningTime,
          sundayClosingTime: this.customer.defaultOfficeHours.sundayClosingTime,
          openWeekdays: this.customer.defaultOfficeHours.openWeekdays,
          openOnSaturday: this.customer.defaultOfficeHours.openOnSaturday,
          openOnSunday: this.customer.defaultOfficeHours.openOnSunday,
        }),
        minCollectionWindow: this.minCollectionWindow,
        minDeliveryWindow: this.minDeliveryWindow,
        serviceDeliveryGroupId: this.customer.serviceDeliveryGroupId,
        enableCustomInvoiceReport: this.customer.enableCustomInvoiceReport,
        restrictCarryover: this.customer.restrictCarryover,
        restrictWeekendCarryover: this.customer.restrictWeekendCarryover,
        carryoverAdditionalMileageThreshold: this.customer.carryoverAdditionalMileageThreshold,
        allowCarryover: this.customer.allowCarryover,
        vehicleLifeCycleEnabled: this.customer.vehicleLifeCycleEnabled,
        supplierAppAccess: this.customer.supplierAppAccess,
        bypassOrderLimitations: this.customer.bypassOrderLimitations,
      });

      if (this.id != 0) {
        this.getCurrentCustomer();
        this.getMobileInformations();

        //additional data requests
        this.tcService.getCurrentlyAgreedTermsConditionsByOrg(this.id).then((res) => {
          this.termsConditions = res;
        });
      } else {
        this.organisationtypespromise.then(() => {
          var organisationTypeId = this.organisationtypes[0].value;
          this.customer.OrganisationTypeId.setValue(organisationTypeId);
          this.changeOrganisationSupTypes(organisationTypeId);
        });
      }
    });

    this.initLifeCycleProviderForm();
  }

  onPostcodeChange(postcode: string) {
    if (postcode !== null && postcode.length > 5) {
      this.onRegionChange(postcode);
    }
  }

  private onRegionChange(postcode: string) {
    this.organisationService
      .getEngineiusRegionFromPostcode(postcode)
      .then((engineiusRegion: IERegion) => {
        this.engineiusRegion = engineiusRegion;
      });
  }

  initOrganisationUserFilter(organisationId) {
    this.organisationUsersFilterVal = {
      first: 0,
      rows: 100,
      sortField: 'Name', // ASC
      sortOrder: 1,
      filters: {
        email: {},
        firstName: {},
        lastName: {},
        organisationTypeId: {},
        organisationId: { value: organisationId },
        roleId: {},
      },
    };
  }

  GetFormControlForCompanyRegNo(value: any) {
    var companyRegNumberExp = new RegExp(/^(((\d{2})|([a-zA-Z]{2}))(\d{6}))$/);
    Validators.compose([null, Validators.maxLength(8), Validators.pattern(companyRegNumberExp)]);
    return new UntypedFormControl(value, (validator: UntypedFormControl) => {
      // Never required - only validated when a value has been entered.
      if (!validator.value) {
        return null;
      }

      var strValue = validator.value as string;
      if (strValue.length > 8) {
        return { valid: false, error: 'Max length is 8' };
      }

      if (!companyRegNumberExp.test(strValue)) {
        return { valid: false, error: 'Wrong format' };
      }

      return null;
    });
  }

  InvoiceAddressSameAsAbove() {
    //this.logger.debug('customer:', this.customer);
    this.newCustomerForm.patchValue({
      invoiceAddress: {
        addressLine1: this.customer.addressLine1.value.toString(),
        addressLine2: this.customer.addressLine2.value.toString(),
        addressLine3: this.customer.addressLine3.value.toString(),
        town: this.customer.town.value,
        city: this.customer.city.value,
        country: this.customer.country.value,
        postCode: this.customer.postcode.value,
      },
    });
  }

  tabChange(e) {
    this.tabIndex = e.index;
  }

  orgtypechange(e) {
    this.customerorgId = e.value;

    if (
      this.customerorgId == OrganisationTypeEnum.Customer ||
      this.customerorgId == OrganisationTypeEnum.SaaSCustomer
    ) {
      this.tabIndex = 0;
    } else if (this.customerorgId == 3) {
      this.tabIndex = 1;
    } else if (this.customerorgId == 4) {
      if (this.tabIndex == 1) {
        this.tabIndex = 0;
      } else {
        this.tabIndex = 1;
        setTimeout(() => {
          this.tabIndex = 0;
        }, 50);
      }
    }
    //this.logger.debug('tabindex:', this.tabIndex);
  }

  getMobileInformations() {
    this.mobileInformationService.getMobileInformationsViaOrganisationId(this.id).then((resp) => {
      this.mobileInformations = resp;
    });
  }

  getCurrentCustomer() {
    this.customerService.get(this.id).then((resp) => {
      this.customerdata = resp;
      // convert from json format to Date
      this.customerdata.preventAutomaticDeactivationExpiryDate = new Date(
        this.customerdata.preventAutomaticDeactivationExpiryDate,
      );
      // this.logger.debug('get customer response:', resp);
      this.customerdata.dateOfBirth = new Date(this.customerdata.dateOfBirth);
      //Fixing Date form primeng TimeControl
      if (this.customerdata.defaultOfficeHours) {
        this.customerdata.defaultOfficeHours.weekOfficeOpeningTime =
          this.customerdata.defaultOfficeHours.weekOfficeOpeningTime.split('+')[0].trim();
        this.customerdata.defaultOfficeHours.weekOfficeClosingTime =
          this.customerdata.defaultOfficeHours.weekOfficeClosingTime.split('+')[0].trim();
        //Saturday
        this.customerdata.defaultOfficeHours.saturdayOpeningTime =
          this.customerdata.defaultOfficeHours.saturdayOpeningTime.split('+')[0].trim();
        this.customerdata.defaultOfficeHours.saturdayClosingTime =
          this.customerdata.defaultOfficeHours.saturdayClosingTime.split('+')[0].trim();
        //Sunady
        this.customerdata.defaultOfficeHours.sundayOpeningTime =
          this.customerdata.defaultOfficeHours.sundayOpeningTime.split('+')[0].trim();
        this.customerdata.defaultOfficeHours.sundayClosingTime =
          this.customerdata.defaultOfficeHours.sundayClosingTime.split('+')[0].trim();
      }
      this.selectedApiDefaultUserId = this.customerdata.defaultAPIUserId;
      this.setFormGroupValues();
      this.organisationtypespromise.then(() => {
        this.changeOrganisationSupTypes(this.customerdata.organisationTypeId);
        setTimeout(
          () => (this.selectOrganisationSubType = this.customerdata.organisationSubTypeId),
        );
        this.selectedOrganisationContractType = this.customerdata.organisationContractTypeId;
      });

      this.organisationService
        .getEngineiusRegionFromPostcode(this.customerdata.postcode)
        .then((engineiusRegion: IERegion) => {
          this.engineiusRegion = engineiusRegion;
        });
    });

    this.organisationSettingService
      .search({
        organisationId: this.id,
        includeOrganisation: true,
        component: 'organisation-custom-settings',
      })
      .then((x) => {
        const minCollectionWindowSettings = x.filter(
          (x) => x.setting == OrganisationSettingEnum.MinCollectionWindow,
        );
        const minDeliveryWindowSettings = x.filter(
          (x) => x.setting == OrganisationSettingEnum.MinDeliveryWindow,
        );

        this.minCollectionWindow.patchValue(
          minCollectionWindowSettings.length > 0
            ? minCollectionWindowSettings[0].intValue
            : this.defaultMinWindow,
        );
        this.minDeliveryWindow.patchValue(
          minDeliveryWindowSettings.length > 0
            ? minDeliveryWindowSettings[0].intValue
            : this.defaultMinWindow,
        );

        this.junoEnabled = x.some(
          (x) =>
            (x.setting == OrganisationSettingEnum.RecommendedRoutesBeta ||
              x.setting == OrganisationSettingEnum.RecommendedRoutesMobileBeta) &&
            x.intValue === 1,
        );

        const defaultToRouteSearchSetting = x.find(
          (x) => x.setting == OrganisationSettingEnum.DefaultToRouteSearch,
        );
        this.defaultSearchType = defaultToRouteSearchSetting?.intValue === 1;
      });
  }

  GotoSpecificSteps() {
    this.router.navigate(['app/customers/specificsteps/' + this.id]);
  }

  setFormGroupValues() {
    const regexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

    var companyRegNumberExp = new RegExp(/^(((\d{2})|([a-zA-Z]{2}))\d{6})$/);
    // set formGroup instance

    let officeHours: IDefaultOfficeHours = null;
    if (this.customerdata.defaultOfficeHours)
      officeHours = {
        weekOfficeOpeningTime: this.customerdata.defaultOfficeHours.weekOfficeOpeningTime
          ? this.customerdata.defaultOfficeHours.weekOfficeOpeningTime
          : '00:00:00',
        weekOfficeClosingTime: this.customerdata.defaultOfficeHours.weekOfficeClosingTime
          ? this.customerdata.defaultOfficeHours.weekOfficeClosingTime
          : '00:00:00',
        saturdayOpeningTime: this.customerdata.defaultOfficeHours.saturdayOpeningTime
          ? this.customerdata.defaultOfficeHours.saturdayOpeningTime
          : '00:00:00',
        saturdayClosingTime: this.customerdata.defaultOfficeHours.saturdayClosingTime
          ? this.customerdata.defaultOfficeHours.saturdayClosingTime
          : '00:00:00',
        sundayOpeningTime: this.customerdata.defaultOfficeHours.sundayOpeningTime
          ? this.customerdata.defaultOfficeHours.sundayOpeningTime
          : '00:00:00',
        sundayClosingTime: this.customerdata.defaultOfficeHours.sundayClosingTime
          ? this.customerdata.defaultOfficeHours.sundayClosingTime
          : '00:00:00',
        weekendOfficeOpeningTime: this.customerdata.defaultOfficeHours.weekOfficeOpeningTime
          ? this.customerdata.defaultOfficeHours.weekOfficeOpeningTime
          : '00:00:00',
        weekendOfficeClosingTime: this.customerdata.defaultOfficeHours.weekOfficeOpeningTime
          ? this.customerdata.defaultOfficeHours.weekendOfficeClosingTime
          : '00:00:00',
        openWeekdays: this.customerdata.defaultOfficeHours.openWeekdays,
        openOnSaturday: this.customerdata.defaultOfficeHours.openOnSaturday,
        openOnSunday: this.customerdata.defaultOfficeHours.openOnSunday,
      };

    var orgDetails = this.customerdata.organisationDetails;

    this.selectOrganisationType = this.customerdata.organisationTypeId;

    let logo = '';
    if (orgDetails) {
      logo = orgDetails.logoUrl;
      this.logoUrl = this.customerdata.logo;
    }

    this.customer = {
      id: 0,
      name: new UntypedFormControl(
        this.customerdata.name,
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      addressLine1: new UntypedFormControl(
        this.customerdata.addressLine1,
        Validators.compose([Validators.required, Validators.maxLength(60), NoEmptyString]),
      ),
      addressLine2: new UntypedFormControl(
        this.customerdata.addressLine2,
        Validators.compose([null, Validators.maxLength(60)]),
      ),
      addressLine3: new UntypedFormControl(
        this.customerdata.addressLine3,
        Validators.compose([null, Validators.maxLength(60)]),
      ),
      country: new UntypedFormControl(
        this.customerdata.country,
        Validators.compose([null, Validators.maxLength(35)]),
      ),
      city: new UntypedFormControl(this.customerdata.city, null),
      emailAddress: new UntypedFormControl(
        this.customerdata.emailAddress,
        Validators.compose([
          Validators.required,
          Validators.maxLength(254),
          Validators.pattern(regexp),
        ]),
      ),
      engineiusCustomerEmail: new UntypedFormControl(
        this.customerdata.engineiusCustomerEmail,
        Validators.compose([Validators.maxLength(254), Validators.pattern(regexp)]),
      ),
      postcode: new UntypedFormControl(
        this.customerdata.postcode,
        Validators.compose([Validators.required, Validators.maxLength(8), NoEmptyString]),
      ),
      town: new UntypedFormControl(
        this.customerdata.town,
        Validators.compose([Validators.required, Validators.maxLength(35), NoEmptyString]),
      ),
      phoneNumber: new UntypedFormControl(
        this.customerdata.phoneNumber.replace('+44', ''),
        Validators.compose([
          Validators.required,
          Validators.maxLength(20),
          Validators.pattern(this.mobileNumberRegExp),
        ]),
      ),
      companyRegistrationNumber: this.GetFormControlForCompanyRegNo(
        this.customerdata.companyRegistrationNumber,
      ),
      OrganisationTypeId: new UntypedFormControl(
        this.customerdata.organisationTypeId,
        Validators.required,
      ),
      OrganisationSubTypeId: new UntypedFormControl(this.customerdata.organisationSubTypeId),
      organisationContractTypeId: new UntypedFormControl(
        this.customerdata.organisationContractTypeId,
      ),
      vatNumber: new UntypedFormControl(
        this.customerdata.vatNumber != null ? this.customerdata.vatNumber.trim() : '',
        Validators.compose([null, Validators.maxLength(9)]),
      ),
      website: new UntypedFormControl(
        this.customerdata.website,
        Validators.compose([null, Validators.maxLength(254)]),
      ),
      companyInfoURL: new UntypedFormControl(
        this.customerdata.companyInfoURL,
        Validators.compose([null, Validators.maxLength(1024)]),
      ),
      ecMaxFlexTimeInMinutes: new UntypedFormControl(this.customerdata.ecMaxFlexTimeInMinutes),
      defaultAPIUserId: new UntypedFormControl(this.customerdata.defaultAPIUserId, null),
      twoFactorStatus: new UntypedFormControl(
        this.customerdata.twoFactorStatus,
        Validators.required,
      ),
      transportMode: new UntypedFormControl(this.customerdata.transportMode, null),
      deactivationReason: new UntypedFormControl(this.customerdata.deactivationReason, null),
      preventAutomaticDeactivation: new UntypedFormControl(
        this.customerdata.preventAutomaticDeactivation,
      ),
      preventAutomaticDeactivationExpiryDate: new UntypedFormControl(
        this.customerdata.preventAutomaticDeactivationExpiryDate,
      ),
      gdprDays: new UntypedFormControl(
        this.customerdata.gdprDays,
        Validators.compose([
          Validators.min(this.systemSettings.gdprDays_MinValue),
          Validators.max(this.systemSettings.gdprDays_MaxValue),
        ]),
      ),
      invoiceAddress: {
        addressLine1: new UntypedFormControl(
          this.customerdata.invoiceAddress ? this.customerdata.invoiceAddress.addressLine1 : '',
          Validators.compose([Validators.required, Validators.maxLength(60), NoEmptyString]),
        ),
        addressLine2: new UntypedFormControl(
          this.customerdata.invoiceAddress ? this.customerdata.invoiceAddress.addressLine2 : '',
          Validators.compose([null, Validators.maxLength(60)]),
        ),
        addressLine3: new UntypedFormControl(
          this.customerdata.invoiceAddress ? this.customerdata.invoiceAddress.addressLine3 : '',
          Validators.compose([null, Validators.maxLength(60)]),
        ),
        town: new UntypedFormControl(
          this.customerdata.invoiceAddress ? this.customerdata.invoiceAddress.town : '',
          Validators.compose([Validators.required, Validators.maxLength(35), NoEmptyString]),
        ),
        city: new UntypedFormControl(
          this.customerdata.invoiceAddress ? this.customerdata.invoiceAddress.city : '',
          null,
        ),
        country: new UntypedFormControl(
          this.customerdata.invoiceAddress ? this.customerdata.invoiceAddress.country : '',
          Validators.compose([null, Validators.maxLength(35)]),
        ),
        postCode: new UntypedFormControl(
          this.customerdata.invoiceAddress ? this.customerdata.invoiceAddress.postCode : '',
          Validators.compose([Validators.required, Validators.maxLength(8), NoEmptyString]),
        ),
        invoiceCompanyName: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceCompanyName
            : null,
          Validators.maxLength(100),
        ),
        invoiceContactFirstName: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceContactFirstName
            : null,
          Validators.maxLength(35),
        ),
        invoiceContactLastName: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceContactLastName
            : null,
          Validators.maxLength(35),
        ),
        invoiceContactEmail: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceContactEmail
            : null,
          Validators.maxLength(254),
        ),
        invoiceContactPhone: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceContactPhone
            : null,
          Validators.maxLength(20),
        ),
        invoiceContact2FirstName: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceContact2FirstName
            : null,
          Validators.maxLength(35),
        ),
        invoiceContact2LastName: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceContact2LastName
            : null,
          Validators.maxLength(35),
        ),
        invoiceContact2Email: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceContact2Email
            : null,
          Validators.maxLength(254),
        ),
        invoiceContact3FirstName: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceContact3FirstName
            : null,
          Validators.maxLength(35),
        ),
        invoiceContact3LastName: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceContact3LastName
            : null,
          Validators.maxLength(35),
        ),
        invoiceContact3Email: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.invoiceContact3Email
            : null,
          Validators.maxLength(254),
        ),
        paymentTermsType: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.paymentTermsType
            : null,
        ),
        paymentTermsDays: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.paymentTermsDays
            : null,
        ),
        purchaseOrderNumber: new UntypedFormControl(
          this.customerdata.invoiceAddress
            ? this.customerdata.invoiceAddress.purchaseOrderNumber
            : null,
          Validators.maxLength(100),
        ),
        invoicePeriod: new UntypedFormControl(
          this.customerdata.invoiceAddress ? this.customerdata.invoiceAddress.invoicePeriod : 0,
        ),
        billingWaitDays: new UntypedFormControl(
          this.customerdata.invoiceAddress ? this.customerdata.invoiceAddress.billingWaitDays : 0,
        ),
      },
      organisationDetails: {
        isSelfInsured: new UntypedFormControl(orgDetails ? orgDetails.isSelfInsured : null),
      },
      defaultOfficeHours: this.officeHoursService.setOfficeHoursForm(officeHours),
      logo: new UntypedFormControl(logo),
      isAddTransactionFee: new UntypedFormControl(this.customerdata.isAddTransactionFee),
      stepTypes: new UntypedFormControl(this.customerdata.stepTypes),
      minCollectionWindow: this.minCollectionWindow,
      minDeliveryWindow: this.minDeliveryWindow,
      enableCustomInvoiceReport: new UntypedFormControl(
        this.customerdata.enableCustomInvoiceReport,
      ),
      serviceDeliveryGroupId: new UntypedFormControl(this.customerdata.serviceDeliveryGroupId),
      dateOfBirth: new UntypedFormControl(this.customerdata.dateOfBirth),
      restrictCarryover: new UntypedFormControl(this.customerdata.restrictCarryover),
      restrictWeekendCarryover: new UntypedFormControl(this.customerdata.restrictWeekendCarryover),
      carryoverAdditionalMileageThreshold: new UntypedFormControl(
        this.customerdata.carryoverAdditionalMileageThreshold,
        [Validators.required, Validators.min(0)],
      ),
      allowCarryover: new UntypedFormControl(!this.customerdata.restrictCarryover),
      vehicleLifeCycleEnabled: new UntypedFormControl(this.customerdata.vehicleLifeCycleEnabled),
      supplierAppAccess: new UntypedFormControl(this.customerdata.supplierAppAccess),
      bypassOrderLimitations: new UntypedFormControl(this.customerdata.bypassOrderLimitations),
    };

    console.log('CUSTOMER', this.customer);

    this.selectedServiceDeliveryGroupId = this.customerdata.serviceDeliveryGroupId;

    this.newCustomerForm = new UntypedFormGroup({
      name: this.customer.name,
      addressLine1: this.customer.addressLine1,
      addressLine2: this.customer.addressLine2,
      addressLine3: this.customer.addressLine3,
      dateOfBirth: this.customer.dateOfBirth,
      country: this.customer.country,
      city: this.customer.city,
      emailAddress: this.customer.emailAddress,
      engineiusCustomerEmail: this.customer.engineiusCustomerEmail,
      postcode: this.customer.postcode,
      town: this.customer.town,
      phoneNumber: this.customer.phoneNumber,
      companyRegistrationNumber: this.customer.companyRegistrationNumber,
      OrganisationTypeId: this.customer.OrganisationTypeId,
      OrganisationSubTypeId: this.customer.OrganisationSubTypeId,
      organisationContractTypeId: this.customer.organisationContractTypeId,
      vatNumber: this.customer.vatNumber,
      website: this.customer.website,
      companyInfoURL: this.customer.companyInfoURL,
      ecMaxFlexTimeInMinutes: this.customer.ecMaxFlexTimeInMinutes,
      logo: this.customer.logo,
      isAddTransactionFee: this.customer.isAddTransactionFee,
      defaultAPIUserId: this.customer.defaultAPIUserId,
      stepTypes: this.customer.stepTypes,
      transportMode: this.customer.transportMode,
      twoFactorStatus: this.customer.twoFactorStatus,
      deactivationReason: this.customer.deactivationReason,
      preventAutomaticDeactivation: this.customer.preventAutomaticDeactivation,
      preventAutomaticDeactivationExpiryDate: this.customer.preventAutomaticDeactivationExpiryDate,
      gdprDays: this.customer.gdprDays,
      minCollectionWindow: this.minCollectionWindow,
      minDeliveryWindow: this.minDeliveryWindow,
      invoiceAddress: new UntypedFormGroup({
        addressLine1: this.customer.invoiceAddress.addressLine1,
        addressLine2: this.customer.invoiceAddress.addressLine2,
        addressLine3: this.customer.invoiceAddress.addressLine3,
        town: this.customer.invoiceAddress.town,
        city: this.customer.invoiceAddress.city,
        country: this.customer.invoiceAddress.country,
        postCode: this.customer.invoiceAddress.postCode,
        invoiceCompanyName: this.customer.invoiceAddress.invoiceCompanyName,
        invoiceContactFirstName: this.customer.invoiceAddress.invoiceContactFirstName,
        invoiceContactLastName: this.customer.invoiceAddress.invoiceContactLastName,
        invoiceContactEmail: this.customer.invoiceAddress.invoiceContactEmail,
        invoiceContactPhone: this.customer.invoiceAddress.invoiceContactPhone,
        invoiceContact2FirstName: this.customer.invoiceAddress.invoiceContact2FirstName,
        invoiceContact2LastName: this.customer.invoiceAddress.invoiceContact2LastName,
        invoiceContact2Email: this.customer.invoiceAddress.invoiceContact2Email,
        invoiceContact3FirstName: this.customer.invoiceAddress.invoiceContact3FirstName,
        invoiceContact3LastName: this.customer.invoiceAddress.invoiceContact3LastName,
        invoiceContact3Email: this.customer.invoiceAddress.invoiceContact3Email,
        paymentTermsType: this.customer.invoiceAddress.paymentTermsType,
        paymentTermsDays: this.customer.invoiceAddress.paymentTermsDays,
        purchaseOrderNumber: this.customer.invoiceAddress.purchaseOrderNumber,
        invoicePeriod: this.customer.invoiceAddress.invoicePeriod,
        billingWaitDays: this.customer.invoiceAddress.billingWaitDays,
      }),
      organisationDetails: new UntypedFormGroup({
        isSelfInsured: this.customer.organisationDetails.isSelfInsured,
      }),
      defaultOfficeHours: new UntypedFormGroup({
        weekOfficeOpeningTime: this.customer.defaultOfficeHours.weekOfficeOpeningTime,
        weekOfficeClosingTime: this.customer.defaultOfficeHours.weekOfficeClosingTime,
        saturdayOpeningTime: this.customer.defaultOfficeHours.saturdayOpeningTime,
        saturdayClosingTime: this.customer.defaultOfficeHours.saturdayClosingTime,
        sundayOpeningTime: this.customer.defaultOfficeHours.sundayOpeningTime,
        sundayClosingTime: this.customer.defaultOfficeHours.sundayClosingTime,
        openWeekdays: this.customer.defaultOfficeHours.openWeekdays,
        openOnSaturday: this.customer.defaultOfficeHours.openOnSaturday,
        openOnSunday: this.customer.defaultOfficeHours.openOnSunday,
      }),
      enableCustomInvoiceReport: this.customer.enableCustomInvoiceReport,
      serviceDeliveryGroupId: this.customer.serviceDeliveryGroupId,
      restrictCarryover: this.customer.restrictCarryover,
      restrictWeekendCarryover: this.customer.restrictWeekendCarryover,
      carryoverAdditionalMileageThreshold: this.customer.carryoverAdditionalMileageThreshold,
      allowCarryover: this.customer.allowCarryover,
      vehicleLifeCycleEnabled: this.customer.vehicleLifeCycleEnabled,
      supplierAppAccess: this.customer.supplierAppAccess,
      bypassOrderLimitations: this.customer.bypassOrderLimitations,
    });

    if (!this.isVmeMode) {
      this.newCustomerForm.get('name').disable();
    }

    console.log('NCV', this.newCustomerForm);
  }

  getOrganisationTypes() {
    return this.customerService.getTypes().then((result) => {
      this.organisationtypes = [];
      if (result != null) {
        var toExclude = '';

        result.forEach((item) => {
          if (item.name != 'VME' && item.name != toExclude) {
            this.organisationtypes.push({ label: item.name, value: item.id });
          }
        });

        return this.getOrganisationSubTypes();
      }
    });
  }

  getOrganisationUsers(filter: IUserFilter) {
    return this.userService.getPage(flatten(filter)).then((result) => {
      this.organisationUsers = [];
      if (result != null) {
        result.items.forEach((item) => {
          if (item) {
            var fullName = item.firstName + ' ' + item.lastName;
            this.organisationUsers.push({ label: fullName, value: item.id });
          }
        });
      }
    });
  }

  /**
   * The key is only fetched when the user explicitly asks to see it, so that each read is a
   * deliberate action and is recorded as such in the server logs.
   */
  revealApiKey() {
    this.apiKeyLoading = true;
    return this.organisationService
      .getApiKey(this.id)
      .then((res) => {
        this.apiKey = res;
        this.apiKeyRevealed = true;
      })
      .catch(() => {
        this.messageService.add(Message.Error('Error while loading api key', 'API Key'));
      })
      .then(() => {
        this.apiKeyLoading = false;
      });
  }

  hideApiKey() {
    this.apiKey = '';
    this.apiKeyRevealed = false;
  }

  copyApiKey() {
    return navigator.clipboard
      .writeText(this.apiKey)
      .then(() => {
        this.messageService.add(Message.Success('API key copied to clipboard', 'API Key'));
      })
      .catch(() => {
        this.messageService.add(Message.Error('Failed to copy api key', 'API Key'));
      });
  }

  confirmApiKeyGeneration() {
    this.showApiKeyChangeDialog = true;
    this.confirmationService.confirm({
      message: this.customerdata.hasApiKey
        ? this.apiKeyDialogMessage.updatedExistingKeyCheckMsg
        : this.apiKeyDialogMessage.createNewKeyCheckMsg,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      key: 'api-key-generation-dialog',
      accept: () => {
        this.generateApiKey();
      },
      reject: () => {},
    });
  }

  generateApiKey() {
    return this.organisationService
      .createApiKey(this.id)
      .then((res) => {
        this.customerdata.hasApiKey
          ? this.messageService.add(
              Message.Success(
                this.apiKeyDialogMessage.confirmExistingKeyUpdatedMsg,
                'Create API Key',
              ),
            )
          : this.messageService.add(
              Message.Success(this.apiKeyDialogMessage.confirmNewKeyCreatedMsg, 'Create API Key'),
            );

        // the user has just generated the key, so there is nothing gained by hiding it from them
        this.customerdata.hasApiKey = true;
        this.apiKey = res;
        this.apiKeyRevealed = true;
      })
      .catch((error) => {
        //this.logger.error('Error Generating API Key', error);
        this.messageService.add(Message.Error('Error while creating api key', 'Create API Key'));
      });
  }

  @Input('selectOrganisationType')
  private _selectOrganisationType: number;
  public set selectOrganisationType(value: number) {
    this._selectOrganisationType = value;
    this.changeOrganisationSupTypes(value);
  }

  public get selectOrganisationType(): number {
    return this._selectOrganisationType;
  }

  @Input('selectOrganisationSubType')
  private _selectOrganisationSubType: number;
  public set selectOrganisationSubType(value: number) {
    this._selectOrganisationSubType = value;
  }

  public get selectOrganisationSubType(): number {
    return this._selectOrganisationSubType;
  }

  getOrganisationSubTypes() {
    return this.customerService.getSubTypes().then((result) => {
      if (result != null) {
        result.forEach((item) => {
          this.allorganisationsubtypes.push(item);
        });
      }

      return result;
    });
  }

  changeOrganisationSupTypes(organisationTypeId: number) {
    this.organisationsubtypes = [];

    this.allorganisationsubtypes.forEach((item) => {
      if (organisationTypeId == 4 || organisationTypeId == item.organisationTypeId) {
        this.organisationsubtypes.push({ label: item.name, value: item.id });
      }
    });

    if (
      this.selectOrganisationType != OrganisationTypeEnum.SaaSCustomer &&
      this.organisationsubtypes.length > 0
    ) {
      this.customer.OrganisationSubTypeId.setValue(this.organisationsubtypes[0].value);
    } else {
      this.customer.OrganisationSubTypeId.setValue(null);
    }
  }

  save(formValues) {
    //Setting default value OrganisationTypeId to the first in the list when OrganisationTypeId Dropdown havent been changed
    if (formValues.OrganisationTypeId < this.customer.OrganisationTypeId.value) {
      formValues.OrganisationTypeId = this.customer.OrganisationTypeId.value;
    }

    // use allow carryover toggle value if supplier
    if (this.selectOrganisationType == 3) {
      formValues.restrictCarryover = !formValues.allowCarryover;
    }

    if (formValues.OrganisationSubTypeId < this.customer.OrganisationSubTypeId.value) {
      formValues.OrganisationSubTypeId = this.customer.OrganisationSubTypeId.value;
    }

    formValues.defaultOfficeHours = this.officeHoursService.fixHoursFormatForSave(
      formValues.defaultOfficeHours,
    );

    if (this.selectOrganisationSubType) {
      formValues.OrganisationSubTypeId = this.selectOrganisationSubType;
    }

    let organisationName = this.organisationtypes.filter(
      (o) => o.value == formValues.OrganisationTypeId,
    )[0].label;

    if (!formValues.OrganisationTypeId) {
      formValues.OrganisationTypeId = this.organisationtypes[0].value;
    }
    formValues.id = this.id;
    //if (this.customerdata) {
    //    formValues.logo = this.customerdata.logo;
    //}

    console.log('Saving customer form: ', formValues);

    let isNewOrg = formValues.id == 0 ? true : false;
    let isVme = this.user == 'vme' ? true : false;

    if (formValues.invoiceAddress.paymentTermsType == -1)
      formValues.invoiceAddress.paymentTermsType == null;

    if (formValues.defaultAPIUserId == -1 || formValues.defaultAPIUserId == '')
      formValues.defaultAPIUserId = null;

    if (this.engineiusRegion != null) {
      formValues.PostcodeERegionId = this.engineiusRegion.id;
    }

    //save it with +44
    if (formValues.phoneNumber != null) {
      formValues.phoneNumber = `+44${formValues.phoneNumber}`;
    }

    this.customerService
      .saveCustomerForm(formValues, isNewOrg, isVme)
      .then((res) => {
        if (res != undefined || res != null) {
          this.router.navigate([this.currentUserOrgTypeId == 1 ? 'app/organisations' : 'app/home']);
        }
      })
      .catch((error) => {
        //this.logger.error('Error Saving Organisation', error);
        const errorMessage = get(error, 'error.Message', 'unknown error');
        const message = `An error occurred, the organisation was not saved: ${errorMessage}`;
        this.messageService.add(Message.Error(message));
      });
  }

  SaveAndRestart(formValues) {
    formValues.defaultOfficeHours = this.officeHoursService.fixHoursFormatForSave(
      formValues.defaultOfficeHours,
    );

    let organisationName = this.organisationtypes.filter(
      (o) => o.value == formValues.OrganisationTypeId,
    )[0].label;

    if (!formValues.OrganisationTypeId) {
      formValues.OrganisationTypeId = this.organisationtypes[0].value;
    }
    formValues.id = this.id;
  }

  onDefaultSearchTypeChange(value: boolean): void {
    this.confirmationService.confirm({
      message: `Are you sure you want to change the default search type to <b>${
        value ? 'Route Search' : 'Job Search'
      }</b>?`,
      accept: () => {
        this.routeRecommendationService.setDefaultRouteSearch(this.id, value).catch(() => {
          this.messageService.add(
            Message.Error('Failed to update default search type. Please try again.'),
          );
          this.defaultSearchType = !value;
        });
      },
      reject: () => {
        this.defaultSearchType = !value;
      },
    });
  }

  cancel() {
    this.router.navigate([this.currentUserOrgTypeId == 1 ? 'app/organisations' : 'app/home']);
  }

  progress: number = 0;
  selectedImage: any;
  showProgressBar: boolean = false;
  files: any;

  onBeforeUpload(event) {
    event.formData.append('lastModifiedDate', this.files[0].LastModifiedDate.getTime());
    event.formData.append('size', '400');
  }

  onError(event) {
    var errorDescripton = 'The following files were not be uploaded: <br/>';
    if (event.files.length > 0) {
      for (let file of event.files) {
        errorDescripton += file.name + '<br/>';
      }
    }

    this.messageService.add(Message.Error('Impossible to add a new logo.', 'File Uploading'));
    //.ShowError('File Uploading', 'Impossible to add a new logo.');
  }

  progressUploading(event) {
    this.progress = event.progress;
  }

  onSelect(event) {
    this.files = [];
    if (event.files.length > 0) {
      for (let file of event.files) {
        var fileDetails = {
          LastModifiedDate: file.lastModifiedDate,
          Name: file.name,
          Size: file.size,
          Type: file.type,
        };
        this.files.push(fileDetails);
      }
    }
  }

  fileUploading(event) {
    var totalUploadedFiles = 0;
    var totalFiles = event.files.length;
    this.progress = 0;

    if (event.files != undefined && event.files.length > 0) {
      this.showProgressBar = true;
      for (let file of event.files) {
        let input = new FormData();
        input.append('file', file);

        this.http
          .post(
            '/api/filestorage/fileuploading?lastModifiedDate=' +
              file.lastModifiedDate.getTime() +
              '&size=400',
            input,
          )
          .toPromise()
          .then((d: any) => {
            var uploadingResult = d;
            if (uploadingResult.isSuccessStatusCode) {
              totalUploadedFiles++;
              this.progress = Math.round((totalUploadedFiles * 100) / totalFiles);
              if (totalUploadedFiles == totalFiles) {
                this.messageService.add(
                  Message.Success('The files have been uploaded successfully.', 'File Uploading'),
                );
                //this.messageService.ShowSuccess('File Uploading', 'The files have been uploaded successfully.');
              }
            } else {
              this.messageService.add(
                Message.Warning(uploadingResult.reasonPhrase, 'File Uploading'),
              );
              //this.messageService.ShowWarning('File Uploading', uploadingResult.reasonPhrase);
              this.showProgressBar = false;
              return;
            }
          });
      }
    }
  }

  onFileUpload(event) {
    //const response = JSON.parse(event.xhr.response);
    const response = event.originalEvent.body;

    //this.logger.debug('parsed:', response);
    if (response.successfully) {
      //this.logger.debug("UPLOAD 1");
      this.customer.logo.setValue(response.fileData.guid);
      this.logoUrl = response.presignedUrl;
      //this.customerdata.logo = response.fileData.url;
      //this.logger.debug("UPLOAD 2");
      this.messageService.add(Message.Success('Logo uploaded.', 'File Uploading'));
      //this.messageService.ShowSuccess('File Uploading', 'Logo uploaded.');
    } else {
      // error
      this.messageService.add(Message.Error('Impossible to add a new logo.', 'File Uploading'));
      //this.messageService.ShowError('File Uploading', 'Impossible to add a new logo.');
    }
  }

  deleteLogo() {
    this.customer.logo.setValue(null);
  }

  openLogo(objectKey) {
    this.fileStorageService.openSourceInTab(objectKey);
  }

  unallocateTradePlate(item) {
    this.confirmationService.confirm({
      message: `Are you sure want to unallocate selected item?`,
      accept: () => {
        this.tradePlateService
          .unallocate(item)
          .then((res) => {
            this.customerdata.tradePlates = this.customerdata.tradePlates.filter((x) => x != item);
          })
          .catch((e) => {
            this.messageService.add(Message.Error('Error while unallocating', 'Unallocate'));
          });
      },
    });
  }

  checkOrganisationName(name: string): Promise<any> {
    if (name.length == 0) {
      return null;
    }

    var checkUrl = 'api/customers/organisationExistsByName/' + encodeURIComponent(name);

    let promise = new Promise((resolve, reject) => {
      this.http
        .get<ValidationResult>(checkUrl)
        .toPromise()
        .then((res) => {
          this.invalidOrganisationName = res.exists && res.id != this.id;

          if (this.invalidOrganisationName) {
            this.newCustomerForm.controls.name.setErrors({ ERROR: res.exists });
          } else {
            this.newCustomerForm.controls.name.setErrors(null);
          }
        });
    });

    return promise;
  }

  manageContractTypeHistory() {
    this.router.navigate([`app/manage-contract-type-history/${this.id}`]);
  }

  showErrors() {
    console.log(this.newCustomerForm);
  }

  serviceDeliveryGroupChanged(event: any) {
    //console.log("Service delivery group changed: ", event);
    if (!this.serviceDeliveryGroups) {
      return;
    }

    let group = this.serviceDeliveryGroups.filter((x) => x.id == event);
    if (group && group.length > 0) {
      this.selectedServiceDeliveryGroup = group[0];
    } else {
      this.selectedServiceDeliveryGroup = null;
    }
  }

  getLifeCycleProviders(): void {
    this.vehicleLifeCycleService.getProviders().then((res) => {
      this.vehicleLifeCycleProviders = res;
      this.getLifeCycleProviderConnections();
    });
  }

  getLifeCycleProviderConnections(): void {
    this.vehicleLifeCycleService.getProviderConnections(this.id).then((res) => {
      this.vehicleLifeCycleProviderConnections = res;
      this.initLifeCycleProviderForm();
    });
  }

  initLifeCycleProviderForm(connection: IVehicleLifeCycleProviderConnection = null): void {
    console.log(connection);
    this.vehicleLifeCycleProviderConnectionFormGroup = new UntypedFormGroup({
      id: new UntypedFormControl(connection?.id ?? 0),
      providerId: new UntypedFormControl(connection?.providerId ?? 0),
      apiUrl: new UntypedFormControl(connection?.apiUrl ?? '', Validators.required),
      usernameKey: new UntypedFormControl(connection?.usernameKey ?? '', Validators.required),
      passwordKey: new UntypedFormControl(connection?.passwordKey ?? '', Validators.required),
      organisationId: new UntypedFormControl(this.id),
    });
  }

  configureLifeCycleProviders(): void {
    this.vehicleLifeCycleSelectedProvider = null;
    this.getLifeCycleProviders();
    this.vehicleLifeCycleManageProvidersVisible = true;
  }

  selectLifeCycleProvider(provider: IVehicleLifeCycleProvider): void {
    let existingProviderConfiguration = this.vehicleLifeCycleProviderConnections.find(
      (x) => x.providerId == provider.id,
    );

    if (existingProviderConfiguration) {
      this.initLifeCycleProviderForm(existingProviderConfiguration);
    } else {
      this.initLifeCycleProviderForm();
      this.vehicleLifeCycleProviderConnectionFormGroup.get('apiUrl').setValue(provider.apiUrl);
      this.vehicleLifeCycleProviderConnectionFormGroup.get('providerId').setValue(provider.id);
    }
  }

  saveLifeCycleProviderConnection(): void {
    if (
      this.vehicleLifeCycleProviderConnectionFormGroup.get('providerId').value == null ||
      this.vehicleLifeCycleProviderConnectionFormGroup.get('providerId').value == 0
    ) {
      this.messageService.add(Message.Warning('Please select a provider from the list'));
      return;
    }

    this.vehicleLifeCycleProviderUpdateSaving = true;
    this.vehicleLifeCycleService
      .addUpdateProviderConnection(this.vehicleLifeCycleProviderConnectionFormGroup.getRawValue())
      .then((res) => {
        this.vehicleLifeCycleProviderConnections = res;
        this.vehicleLifeCycleProviderUpdateSaving = false;
        this.messageService.add(Message.Success('Provider updated successfully'));
      })
      .catch((err) => {
        this.vehicleLifeCycleProviderUpdateSaving = false;
      });
  }

  initAddressAutoCompletionFields(): void {
    const addressSearchFields = [
      { element: 'name', field: '', parentContainer: '', showSavedSites: false },
      { element: 'addressLine1', field: '', parentContainer: '', showSavedSites: false },
      { element: 'addressLine2', field: '', parentContainer: '', showSavedSites: false },
      { element: 'town', field: '', parentContainer: '', showSavedSites: false },
      { element: 'city', field: '', parentContainer: '', showSavedSites: false },
      { element: 'postcode', field: '', parentContainer: '', showSavedSites: false },
    ];

    this.addressAutoCompletionService.useWithDefaultAddressResponse(
      addressSearchFields,
      (address) => {
        let formUpdate: any = {
          addressLine1: address.line_1,
          addressLine2: address.line_2,
          addressLine3: address.line_3,
          town: address.town_or_city,
          postcode: address.postcode,
        };

        if (this.isVmeMode) {
          formUpdate.name = address.businessName;
        }

        this.newCustomerForm.patchValue(formUpdate);
      },
    );

    const invoiceAddressFields = [
      { element: 'invoice_addressLine1', field: '', parentContainer: '', showSavedSites: false },
      { element: 'invoice_addressLine2', field: '', parentContainer: '', showSavedSites: false },
      { element: 'invoice_town', field: '', parentContainer: '', showSavedSites: false },
      { element: 'invoice_city', field: '', parentContainer: '', showSavedSites: false },
      { element: 'invoice_postcode', field: '', parentContainer: '', showSavedSites: false },
    ];

    this.addressAutoCompletionService.useWithDefaultAddressResponse(
      invoiceAddressFields,
      (address) => {
        this.newCustomerForm.patchValue({
          invoiceAddress: {
            addressLine1: address.line_1,
            addressLine2: address.line_2,
            addressLine3: address.line_3,
            town: address.town_or_city,
            postCode: address.postcode,
          },
        });
      },
    );
  }
}

interface ValidationResult {
  exists: boolean;
  id: number;
}
